import React, { useEffect, useState } from 'react';
import RouteBuilder from 'src/utils/routing/RouteBuilder';
import { useRouteBuilder } from 'src/utils/routing/RouteBuilderContext';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import FrequencyTypeForm from 'src/components/FrequencyTypeForm/FrequencyTypeForm';
import { GetFrequencyTypesAdminResponse } from 'src/types/apiResponse';
import { FrequencyType } from 'src/types/frequencyType';
import { getFromApi } from 'src/utils/getFromApi';
import { AxiosError } from 'axios';

function EditFrequencyTypePage(): FunctionComponentReturnType {
    const [data, setData] = useState<GetFrequencyTypesAdminResponse | null>(null);
    const [error, setError] = useState<AxiosError | null>(null);
    const routeBuilder: RouteBuilder = useRouteBuilder();
    const apiRoute: string = routeBuilder.api.getAllFrequenciesAdmin();

    useEffect(getFromApi(apiRoute, setData, setError), [apiRoute]);

    if (error) {
        throw error;
    }

    let frequencyType: FrequencyType | null = null;
    if (data) {
        frequencyType = data.frequencyTypes.find(x => {
            return x.code === routeBuilder.getFrequencyTypeCode();
        }) || null;
    }

    return data && frequencyType && <FrequencyTypeForm
        frequencyTypes={data.frequencyTypes}
        frequencyType={frequencyType}
    />;
}

export default EditFrequencyTypePage;
